import React, { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import AssignLockerOnMap from "./AssignOnMap";
import { SearchParcelatMachinesAsync } from "../../actions/parcelatActions";
import { useDispatch, useSelector } from "react-redux";
import AppStateModel from "../../models/appStateModel";
import { IMachinesMappedData, machinesMapper } from "../../models/parcelat";
import {ChnageParcelatCourier, ReserveLocker} from "../../api/data";
import { SetAlert } from "../../actions/common";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
    shipmentId?:string
}

const ChooseLockerModal = ({ onClose, isOpen, shipmentId }: IProps) => {
  const [lockerInfo, setLockerInfo] = useState<IMachinesMappedData>({});

  const dispatch = useDispatch();
  const location = useLocation();

  const parcelatMachines = useSelector(
    (state: AppStateModel) => state.ParcelatMachines
  );

  useEffect(() => {
    dispatch(SearchParcelatMachinesAsync());
  }, [dispatch]);

  const mappedMachines = useMemo(() => {
    return machinesMapper(parcelatMachines?.machines?.result);
  }, [parcelatMachines?.machines]);

  const getShipmentId = () => {
    const params = new URLSearchParams(location.search);
    return params.get("shipmentId") ?? shipmentId ?? "";
  };
  
  const handleSubmit = async () => {
    const shipmentId = getShipmentId();
    const res = await ReserveLocker({ machineName: lockerInfo.name, shipmentId, machineLockerLocation: lockerInfo.googleUrl });

    if (res.succeeded) {
      const editRes = await  ChnageParcelatCourier({id: shipmentId , newUser:"integrationusr"})
      if(editRes.status){
        dispatch(

            SetAlert({
              visible: true,
              data: "",
              title: "Success",
              kind: "success",
            })
        );
      }else{
        dispatch(
            SetAlert({
              visible: true,
              data: res.data,
              title: "Error",
              kind: "error",
            })
        );
      }
    } else {
      dispatch(
        SetAlert({
          visible: true,
          data: res.data,
          title: "Error",
          kind: "error",
        })
      );
    }
    
    onClose();
  };
    
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="modal-100w"
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {"Click On A Location Icon To Choose A Locker"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          <Card.Body style={{ height: "70vh", display: "flex", flexDirection: "column", padding: 0 }}>
            <div style={{ flex: lockerInfo ? "0 0 auto" : "0 0 auto", padding: 16 }}>
              {lockerInfo ? (
                <div>
                  {lockerInfo.displayName && <p style={{fontSize: 14}}><strong>Locker Name:</strong> {lockerInfo.displayName}</p>}
                  {lockerInfo.address1 && <p style={{fontSize: 14}}><strong>Address:</strong> {lockerInfo.address1}</p>}
                  {lockerInfo.street && <p style={{fontSize: 14}}><strong>Street Name:</strong> {lockerInfo.street}</p>}
                  {lockerInfo.googleUrl && <p style={{fontSize: 14}}><strong>Google Maps URL:</strong> <a href={lockerInfo.googleUrl} target="_blank" rel="noopener noreferrer">View on Maps</a></p>}
                </div>
              ) : (
                <p>Select a locker to see details</p>
              )}
            </div>
            <div style={{ flex: "1 1 0", minHeight: 0 }}>
              <AssignLockerOnMap
                setLockerInfo={setLockerInfo}
                machines={mappedMachines}
                mapHeight={"100%"}
              />
            </div>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ display: "flex",flexDirection:"row", paddingTop:10, gap: 10 }}>
        <Button size={"lg"} onClick={onClose}>Close</Button>
        <Button size={"lg"} onClick={handleSubmit} disabled={!lockerInfo.name}>Submit</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChooseLockerModal;
